import script from "./ApplyLeave.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplyLeave.vue?vue&type=script&setup=true&lang=js"

import "./ApplyLeave.vue?vue&type=style&index=0&id=cca45ec4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cca45ec4"]])

export default __exports__